/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gc_stat_at = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AT content`)
};

const es_gc_stat_at = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenido AT`)
};

const de_gc_stat_at = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AT-Gehalt`)
};

const nl_gc_stat_at = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AT-gehalte`)
};

const fr_gc_stat_at = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenu AT`)
};

const it_gc_stat_at = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenuto AT`)
};

const pt_br2_gc_stat_at = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteúdo AT`)
};

const pt_gc_stat_at = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteúdo AT`)
};

const ja_gc_stat_at = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AT含量`)
};

const zh_gc_stat_at = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AT 含量`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gc_stat_at = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gc_stat_at(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gc_stat_at", locale)
	if (locale === "en") return en_gc_stat_at(inputs)
	if (locale === "es") return es_gc_stat_at(inputs)
	if (locale === "de") return de_gc_stat_at(inputs)
	if (locale === "nl") return nl_gc_stat_at(inputs)
	if (locale === "fr") return fr_gc_stat_at(inputs)
	if (locale === "it") return it_gc_stat_at(inputs)
	if (locale === "pt-BR") return pt_br2_gc_stat_at(inputs)
	if (locale === "pt") return pt_gc_stat_at(inputs)
	if (locale === "ja") return ja_gc_stat_at(inputs)
	return zh_gc_stat_at(inputs)
};